import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import ConsultationModal from '../components/ConsultationModal';

const ConsultationModalContext = createContext(null);

export function ConsultationModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [initialProject, setInitialProject] = useState('Kitchen remodeling');

  const openConsultationModal = useCallback((projectType = 'Kitchen remodeling') => {
    setInitialProject(projectType);
    setIsOpen(true);
  }, []);

  const closeConsultationModal = useCallback(() => setIsOpen(false), []);
  const value = useMemo(() => ({ openConsultationModal, closeConsultationModal }), [openConsultationModal, closeConsultationModal]);

  return (
    <ConsultationModalContext.Provider value={value}>
      {children}
      <ConsultationModal isOpen={isOpen} initialProject={initialProject} onClose={closeConsultationModal} />
    </ConsultationModalContext.Provider>
  );
}

export function useConsultationModal() {
  const context = useContext(ConsultationModalContext);
  if (!context) throw new Error('useConsultationModal must be used within a ConsultationModalProvider');
  return context;
}
